export interface BasketItem {
  id: number;
  productID: number;
  productName: string;
  optionName?: string;
  quantity: number;
  stock: number;
}

export const basketItemFromResponse = (responseData: any): BasketItem => ({
  id: responseData.id,
  productID: responseData.product_id,
  productName: responseData.product_name,
  optionName: responseData.option_name,
  quantity: responseData.quantity,
  stock: responseData.stock,
});
